import { HttpResponse } from "@angular/common/http";
import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { ReportEvaluationResourceFiltersDTO } from "../../models/export-report.model";
import { ProjectEvaluationRepository } from "../../repositories/project-evaluation.repository";

export class ExportResourceReportUseCase
  implements UseCase<ReportEvaluationResourceFiltersDTO, HttpResponse<Blob>>
{
  constructor(private repo: ProjectEvaluationRepository) {}
  
  execute(filters: ReportEvaluationResourceFiltersDTO): Observable<HttpResponse<Blob>> {
    return this.repo.exportResourceReport(filters);
  }
}

const exportResourceReportUseCaseFactory = (repo: ProjectEvaluationRepository) =>
  new ExportResourceReportUseCase(repo);

export const exportResourceReportUseCaseProvider: Provider = {
  provide: ExportResourceReportUseCase,
  useFactory: exportResourceReportUseCaseFactory,
  deps: [ProjectEvaluationRepository],
};
